var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"settings-box"},[_c('div',{staticClass:"section-title"},[_c('i',{staticClass:"fa-regular fa-envelope-open-dollar pr-1"}),_vm._v(" "+_vm._s(_vm.$t('settings.paymentGateways'))+" ")]),_c('PaymentGateways')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }